import { createRouter, createWebHistory } from "vue-router";
import {baseUrl} from "./config";
import {readCookie} from "./utils";

const Home = () => import('./pages/Home.vue');
const Register = () => import('./pages/Register.vue');
const Login = () => import('./pages/Login.vue');
const Onboarding = () => import('./pages/Onboarding.vue');
const Offer = () => import('./pages/Offer.vue');
const LicenseAgreement = () => import('./pages/LicenseAgreement.vue');
const RequirementsForPostedMaterials = () => import('./pages/RequirementsForPostedMaterials.vue');
const NotFound = () => import('./pages/NotFound.vue');

const AUTH_REDIRECT_ONBOARDING_PATHS = ['/', '/login', '/register'];

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home,
        meta: {
            guest: false,
        }
    },
    {
        path: '/register',
        name: 'register',
        component: Register,
        meta: {
            header: false,
            guest: true
        }
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: {
            header: false,
            guest: true
        }
    },
    {
        path: '/onboarding',
        name: 'onboarding',
        component: Onboarding,
        meta: {
            guest: false,
            header: false
        }
    },
    {
        path: '/offer',
        name: 'offer',
        component: Offer,
        meta: {
            guest: true
        }
    },
    {
        path: '/license-agreement',
        name: 'LicenseAgreement',
        component: LicenseAgreement,
        meta: {
            guest: true
        }
    },
    {
        path: '/requirements-for-posted-materials',
        name: 'RequirementsForPostedMaterials',
        component: RequirementsForPostedMaterials,
        meta: {
            guest: true
        }
    },
    {
        path: "/:catchAll(.*)",
        component: NotFound,
    },
];

const router = createRouter({
    mode: 'history',
    linkExactActiveClass: 'is-active',
    base: baseUrl,
    history: createWebHistory(),
    routes,
});

router.beforeEach((to, from, next) => {
    const auth = readCookie('auth');
    const onboarding = readCookie('onboarding');

    const isAuthenticated = auth === 'true';
    const isOnboardingIncomplete = onboarding === 'false';

    if (!isAuthenticated && to.path !== '/login' && !to.meta.guest) {
        next('/login');
        return;
    }

    if (isAuthenticated && isOnboardingIncomplete && AUTH_REDIRECT_ONBOARDING_PATHS.includes(to.path)) {
        next('/onboarding');
        return;
    }

    if (isAuthenticated && to.path === '/login') {
        next(from.path);
        return;
    }

    if (isAuthenticated && isOnboardingIncomplete && to.path !== '/onboarding' && !to.meta.guest) {
        next('/onboarding');
        return;
    }

    next();
});

export default router;
